<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Configure Staff Lightspeed User</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body pb-0">
    <h3 *ngIf="loadingLightspeedUsers" class="text-secondary mb-3">Loading users...</h3>

    <ng-container *ngIf="!loadingLightspeedUsers">
      <p>
        Staff User:
        <b>{{ getStaffNameDisplay(user.first_name, user.last_name, user.email) }}</b>
        <br>
        <ng-container *ngIf="user.lightspeed_user_id">
          Current Capitan Lightspeed User:
          <b>{{ user.lightspeed_user_username }}</b>
          <br>
          Display Name:
          <b>{{ user.lightspeed_user_display_name }}</b>
          <br>
          ID:
          <b>{{ user.lightspeed_user_id }}</b>
        </ng-container>
        <ng-container *ngIf="!user.lightspeed_user_id">
          Current Capitan Lightspeed User:
          <span class="text-muted">
            None
          </span>
        </ng-container>
      </p>

      <div class="alert alert-info">
        The selected Lightspeed user account will be associated with Capitan actions using the Lightspeed API. This is required in order to send Staff Site sales to Lightspeed for payment.
        <br><br>
        If the staff user making the sale has a linked Lightspeed user account, that account will be used instead when sending Staff Site sales to Lightspeed.
      </div>

      <select class="custom-select mb-3"
              [(ngModel)]="selectedLightspeedUser">
        <option [ngValue]="null"
                [disabled]="user.lightspeed_user_id === ''"
                [class.disabled]="user.lightspeed_user_id === ''">
          {{ (user.lightspeed_user_id === '') ? '-- Select a User --' : 'Unlink User' }}
        </option>
        <option *ngFor="let lightspeedUser of lightspeedUserList"
                [ngValue]="lightspeedUser">
          {{ lightspeedUser.username }} ({{ lightspeedUser.display_name }})
        </option>
      </select>
    </ng-container>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            [disabled]="(user.lightspeed_user_id === '') && (selectedLightspeedUser === null)"
            [class.disabled]="(user.lightspeed_user_id === '') && (selectedLightspeedUser === null)"
            (click)="handleSubmit()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
